import { AuthorizedContent } from './authorized-content';

export * from './authorized-content-props';

export default AuthorizedContent;
